import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const MainContainer = styled.div`
  display: flex;
  padding: ${props => props.padding};
  background-color: ${props => props.customBackgroundColor || props.backgroundColor};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  padding: ${props =>
    props.padding || `${props.theme.spacing.sp8} ${props.theme.spacing.sp16} ${props.theme.spacing.sp16}`};
`

export const InfoContainer = styled.div`
  width: calc(100% - 5.25rem);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NameContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
`

export const Name = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
  margin-left: ${props => (props.showSwitch ? '-24px' : '0')}; //to fix the margin-right of the switch
  margin-bottom: ${props => (props.showSwitch ? '0' : '8px')}; //to fix the margin-bottom of the switch

  > div {
    display: grid;
  }

  label {
    color: ${props => (props.isEnabled ? props.theme.colors.text.default : props.theme.colors.text.subtle)};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const CarrierLogo = styled.img`
  height: ${props => props.theme.size.S};
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
`

export const TagsAndRegionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const TagsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};

  > svg {
    min-width: ${props => props.theme.size.S};
  }
`

export const RegionsText = styled(Text)`
  margin: 0;
  color: ${props => props.theme.colors.text.default};
  max-width: calc(60% - 16px);
  min-width: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
`
export const IdentifierContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp16};
  padding-left: 0px;
  color: ${props => props.theme.colors.text.subtle};
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  margin-right: ${props => props.theme.spacing.sp16};
  min-width: 50px;
`

export const ConfigInfoContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
`
